module.exports = __webpack_public_path__ + "static/media/4. Share Jira context in reports.6e9bb864.svg";